import React, { ReactNode } from 'react';
import { Alert } from 'reactstrap';

interface AlertMessageProps {
  message?: ReactNode;
  visibility?: boolean;
}

const AlertMessage = ({ message = '', visibility = false }: AlertMessageProps) => {
  if (visibility)
    return (
      <div style={styles.container} data-testid="alert-message">
        <Alert color="danger">{message}</Alert>
      </div>
    );
  else return null;
};

export { AlertMessage };

const styles = {
  container: {
    marginBottom: '5px',
    marginTop: '5px',
    width: '100%'
  }
};
